import { Route, Routes } from "react-router-dom";
import AvanegarLanding from "./pages/AvaNegarLanding";
import ReactGA from "react-ga4";
import { env } from "./.env";
import Role from "./components/Roles";

function App() {
  ReactGA.initialize(env.REACT_APP_GA4_MEASUREMENT_ID);

  return (
    <>
      <Routes>
        <Route exact path="/" element={<AvanegarLanding />} />
        <Route path="/roles" element={<Role />} />
      </Routes>
    </>
  );
}

export default App;
